import React from 'react';
import ViscosityCalculator from './components/ViscosityCalculator';
// import './styles.css'; // Asegúrate de crear este archivo con los estilos CSS

function App() {
  return (
    <div className="App">
      <ViscosityCalculator />
    </div>
  );
}

export default App;
